import React from 'react';
import { has, get } from "lodash"

import { lbsToKg, kgToLbs } from "./../../../utils/converter"
import { sexData } from "../sex/static.sexData"
import { resultData } from "../result/static.resultData"
import locales from "./../../../content.json"

import { currentWeightTypeData } from "./../currentWeight/static.currentWeightData"
import { goalWeightTypeData } from "./../goalWeight/static.goalWeightData"

import styles from "./graficResultBlock.module.scss"

const UP_WEIGHT = "up"
const LOST_WEIGHT = "lost"
const UNCHANGE_WEIGHT = "unchanged"

const weightVector = (currentWeight, goalWeight) => {
  return currentWeight < goalWeight
    ? UP_WEIGHT
    : currentWeight > goalWeight
      ? LOST_WEIGHT
      : UNCHANGE_WEIGHT
}

const getNowWeightCellHeight = (weightType) => {
  switch (weightType) {
    case UP_WEIGHT:
      return styles.innerUp

    case LOST_WEIGHT:
      return styles.innerDown

    case UNCHANGE_WEIGHT:
      return styles.normal
  }
}

const getGoalWeightCellHeight = (weightType) => {
  switch (weightType) {
    case UP_WEIGHT:
      return styles.innerDown

    case LOST_WEIGHT:
      return styles.innerUp

    case UNCHANGE_WEIGHT:
      return styles.normal
  }
}

const getCenterWeightCell = (weightType) => {
  switch (weightType) {
    case UP_WEIGHT:
      return styles.innerUp

    case LOST_WEIGHT:
      return styles.innerDown

    case UNCHANGE_WEIGHT:
      return styles.normal
  }
}

const getTitleGrafic = (currentWeight, goalWeight, unit, text) => {

  let weightTypeLocales = unit === "lbs" 
        ? locales[window.userLang].lbs_value
        : locales[window.userLang].kg_value;

  if (goalWeight < currentWeight)
    return <span>{locales[window.userLang].lose_up} <strong>{currentWeight - goalWeight}{weightTypeLocales}</strong></span>
  if (goalWeight > currentWeight)
    return <span>{locales[window.userLang].will_gain} <strong>{goalWeight - currentWeight}{weightTypeLocales}</strong></span>
  if (goalWeight === currentWeight)
    return <span>{locales[window.userLang].recommendations}</span>
}

const GraficResultBlock = (props) => {
  const { data } = props
  let currentWeight = get(data, ["currentWeight", "type"]) !== get(data, ["goalWeight", "type"])
    ? get(data, ["goalWeight", "type"]) === goalWeightTypeData.kg.value
      ? lbsToKg(get(data, ["currentWeight", "value"]))
      : get(data, ["goalWeight", "type"]) === goalWeightTypeData.lbs.value
        ? kgToLbs(get(data, ["currentWeight", "value"]))
        : get(data, ["currentWeight", "value"])
    : get(data, ["currentWeight", "value"])
  let goalWeight = get(data, ["goalWeight", "value"])

  console.log('ffff:', data);

  currentWeight = parseFloat(currentWeight.toFixed(2))
  goalWeight = parseFloat(goalWeight.toFixed(2))

  let text = get(data, ["sex", "value"]) === sexData.male.value
  ? get(data, ["result", "value"]) === resultData.male.lose.value
    ? locales[window.userLang].loss_plan
    : get(data, ["result", "value"]) === resultData.male.muscle.value
      ? locales[window.userLang].gain_plan
      : locales[window.userLang].fitness_plan
  : get(data, ["sex", "value"]) === sexData.female.value
    ? get(data, ["result", "value"]) === resultData.female.lose.value
      ? locales[window.userLang].loss_plan
      : get(data, ["result", "value"]) === resultData.female.tone.value
        ? locales[window.userLang].fitness_plan
        : get(data, ["result", "value"]) === resultData.female.love.value
          ? locales[window.userLang].fitness_plan
          : locales[window.userLang].fitness_plan
    : get(data, ["sex", "value"]) === sexData.other.value
      ? locales[window.userLang].loss_plan
      : get(data, ["result", "value"]) === resultData.other.tone.value
        ? locales[window.userLang].fitness_plan
        : get(data, ["result", "value"]) === resultData.other.love.value
          ? locales[window.userLang].fitness_plan
          : locales[window.userLang].fitness_plan

  return (
    <div className={styles.graficResult}>
      <p className={styles.titleBlock}>
        {
          getTitleGrafic(currentWeight, goalWeight, get(data, ["goalWeight", "type"]), text)
        }
      </p>

      <div className={styles.graficWrapper}>
        <div className={styles.leftCell}>
          <span className={styles.titleCell}>{locales[window.userLang].current_weight}</span>
          <span className={styles.valueCell}><b>{currentWeight}</b>{get(data, ["goalWeight", "type"]) === "lbs" ? locales[window.userLang].lbs_value : locales[window.userLang].kg_value}</span>
          <div className={styles.cellInner}>
            <div className={styles.column}>
              <div className={getNowWeightCellHeight(weightVector(currentWeight, goalWeight))}></div>
            </div>
            <span className={styles.title}>{locales[window.userLang].now}</span>
          </div>
        </div>

        <div className={styles.centerCell}>
          <div className={getCenterWeightCell(weightVector(currentWeight, goalWeight))}>
            <div className={styles.columns}>
              <div className={styles.column}>
                <span className={styles.number}>1</span>
              </div>
              <div className={styles.column}>
                <span className={styles.number}>2</span>
              </div>
              <div className={styles.column}>
                <span className={styles.number}>3</span>
              </div>
              <div className={styles.column}>
                <span className={styles.number}>4</span>
              </div>
              <div className={styles.column}>
                <span className={styles.number}>5</span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.rightCell}>
          <span className={styles.titleCell}>{locales[window.userLang].goal_weight}</span>
          <span className={styles.valueCell}><b>{goalWeight}</b>{get(data, ["goalWeight", "type"]) === "lbs" ? locales[window.userLang].lbs_value : locales[window.userLang].kg_value}</span>
          <div className={styles.cellInner}>
            <div className={styles.column}>
              <div className={getGoalWeightCellHeight(weightVector(currentWeight, goalWeight))}></div>
            </div>
            <span className={styles.title}>{locales[window.userLang].week_6}</span>
          </div>
        </div>
      </div>

      <p className={styles.additionText}>{locales[window.userLang].consult_warning}</p>
    </div>
  )
}

export default GraficResultBlock;